import { Component, ChangeDetectionStrategy } from '@angular/core';
import { HeaderService } from '../header.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { TranslateRouterLinkPipe } from '../../../core';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    TranslateModule,
    MatSidenavModule,
    MatListModule,
    RouterModule,
    TranslateRouterLinkPipe,
    MatExpansionModule,
  ],
})
export class SideNavComponent {
  constructor(public headerService: HeaderService) {}

  onSideNavLinkClick() {
    this.headerService.isSideNavOpen$.next(false);
  }
}
